module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "roller"
  }, [_c('b-modal', {
    attrs: {
      "id": "pushLimitModal",
      "title": "Push the Limit!"
    },
    on: {
      "ok": _vm.pushLimitOk
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Enter your Edge attribute:"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "number",
      "formatter": _vm.zeroOrGreater,
      "lazy-formatter": ""
    },
    model: {
      value: (_vm.userData.edge),
      callback: function($$v) {
        _vm.userData.edge = $$v
      },
      expression: "userData.edge"
    }
  })], 1)], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "clearRollHistoryModal",
      "ok-title": "Yes",
      "hide-header": true
    },
    on: {
      "ok": _vm.clearRollHistory
    }
  }, [_c('h5', [_c('span', {
    staticClass: "text-warning mr-2"
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "exclamation-triangle"
    }
  })], 1), _vm._v("\n      Are you sure you want to delete your entire roll history?\n    ")])]), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "lg": "4"
    }
  }, [_c('b-card', {
    staticClass: "mb-2 roller-settings",
    attrs: {
      "no-body": "",
      "border-variant": "primary"
    }
  }, [_c('b-tabs', {
    attrs: {
      "card": ""
    }
  }, [_c('b-tab', {
    attrs: {
      "title": "Roll",
      "active": ""
    }
  }, [_c('b-form-group', {
    staticClass: "mb-0"
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Label",
      "description": "Optional! Use this to remember why you rolled."
    }
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_c('b-input-group', {
    staticStyle: {
      "margin-right": "-1px"
    }
  }, [_c('b-input-group-button', [_c('b-dropdown', [_c('b-dropdown-header', [_vm._v("Hit presets" + _vm._s(_vm.hitsPresets.length === 0 ? ' (none saved yet!)' : ''))]), _vm._v(" "), _vm._l((_vm.hitsPresets), function(preset) {
    return _c('b-dropdown-item', {
      key: preset.label,
      on: {
        "click": function($event) {
          _vm.loadPreset(preset)
        }
      }
    }, [_vm._v("\n                              " + _vm._s(preset.label) + "\n                              "), _c('span', {
      staticClass: "text-muted"
    }, [_vm._v("\n                                —\n                                "), _c('font-awesome-icon', {
      attrs: {
        "icon": "clone",
        "fixed-width": ""
      }
    }), _vm._v(" " + _vm._s(preset.dicePool) + "\n                                "), _c('font-awesome-icon', {
      attrs: {
        "icon": "arrow-to-top",
        "fixed-width": ""
      }
    }), _vm._v(" " + _vm._s(preset.useLimit ? preset.limit : 'N/A') + "\n                              ")], 1)])
  }), _vm._v(" "), _c('b-dropdown-divider'), _vm._v(" "), _c('b-dropdown-header', [_vm._v("Sum presets" + _vm._s(_vm.sumPresets.length === 0 ? ' (none saved yet!)' : ''))]), _vm._v(" "), _vm._l((_vm.sumPresets), function(preset) {
    return _c('b-dropdown-item', {
      key: preset.label,
      on: {
        "click": function($event) {
          _vm.loadPreset(preset)
        }
      }
    }, [_vm._v("\n                              " + _vm._s(preset.label) + "\n                              "), _c('span', {
      staticClass: "text-muted"
    }, [_vm._v("\n                                —\n                                " + _vm._s(preset.baseValue) + " + " + _vm._s(preset.dicePool) + "d6\n                              ")])])
  })], 2)], 1), _vm._v(" "), _c('b-form-input', {
    model: {
      value: (_vm.userData.rollSettings.label),
      callback: function($$v) {
        _vm.userData.rollSettings.label = $$v
      },
      expression: "userData.rollSettings.label"
    }
  })], 1), _vm._v(" "), _c('b-button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.window.hover",
      modifiers: {
        "window": true,
        "hover": true
      }
    }],
    staticClass: "ml-1",
    attrs: {
      "title": "Save preset",
      "variant": "success"
    },
    on: {
      "click": _vm.savePreset
    }
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "save",
      "fixed-width": ""
    }
  })], 1), _vm._v(" "), _c('b-button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.window.hover",
      modifiers: {
        "window": true,
        "hover": true
      }
    }],
    staticClass: "ml-1",
    attrs: {
      "title": "Delete preset",
      "variant": "danger"
    },
    on: {
      "click": _vm.deletePreset
    }
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "trash",
      "fixed-width": ""
    }
  })], 1)], 1)])], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Mode"
    }
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('b-form-radio-group', {
    attrs: {
      "buttons": "",
      "button-variant": "outline-primary text-white",
      "name": "radiosBtnDefault"
    },
    model: {
      value: (_vm.userData.rollSettings.mode),
      callback: function($$v) {
        _vm.userData.rollSettings.mode = $$v
      },
      expression: "userData.rollSettings.mode"
    }
  }, [_c('b-form-radio', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.window.hover",
      modifiers: {
        "window": true,
        "hover": true
      }
    }],
    attrs: {
      "value": "hits",
      "title": "Count hits and misses. Use this for most tests."
    }
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "crosshairs",
      "fixed-width": ""
    }
  }), _vm._v(" Hits\n                        ")], 1), _vm._v(" "), _c('b-form-radio', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.window.hover",
      modifiers: {
        "window": true,
        "hover": true
      }
    }],
    attrs: {
      "value": "sum",
      "title": "Count the total roll. Use this for e.g. initiative."
    }
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "plus",
      "fixed-width": ""
    }
  }), _vm._v(" Sum\n                        ")], 1)], 1)], 1)])], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', [_c('span', {
    slot: "label"
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "clone",
      "fixed-width": ""
    }
  }), _vm._v(" Dice pool\n                    ")], 1), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "type": "number",
      "formatter": _vm.zeroOrGreater,
      "lazy-formatter": ""
    },
    model: {
      value: (_vm.userData.rollSettings.dicePool),
      callback: function($$v) {
        _vm.userData.rollSettings.dicePool = $$v
      },
      expression: "userData.rollSettings.dicePool"
    }
  })], 1)], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [(_vm.userData.rollSettings.mode === 'hits') ? _c('b-form-group', [_c('span', {
    slot: "label"
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "arrow-to-top",
      "fixed-width": ""
    }
  }), _vm._v(" Limit\n                      ")], 1), _vm._v(" "), _c('b-input-group', [_c('b-input-group-addon', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userData.rollSettings.useLimit),
      expression: "userData.rollSettings.useLimit"
    }, {
      name: "b-tooltip",
      rawName: "v-b-tooltip.window.hover",
      modifiers: {
        "window": true,
        "hover": true
      }
    }],
    attrs: {
      "type": "checkbox",
      "title": "Uncheck to ignore limit."
    },
    domProps: {
      "checked": Array.isArray(_vm.userData.rollSettings.useLimit) ? _vm._i(_vm.userData.rollSettings.useLimit, null) > -1 : (_vm.userData.rollSettings.useLimit)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.userData.rollSettings.useLimit,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.userData.rollSettings.useLimit = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.userData.rollSettings.useLimit = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.userData.rollSettings.useLimit = $$c
        }
      }
    }
  })]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "type": "number",
      "formatter": _vm.zeroOrGreater,
      "disabled": !_vm.userData.rollSettings.useLimit,
      "lazy-formatter": ""
    },
    model: {
      value: (_vm.userData.rollSettings.limit),
      callback: function($$v) {
        _vm.userData.rollSettings.limit = $$v
      },
      expression: "userData.rollSettings.limit"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.userData.rollSettings.mode === 'sum') ? _c('b-form-group', [_c('span', {
    slot: "label"
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "arrow-to-bottom",
      "fixed-width": ""
    }
  }), _vm._v(" Base value\n                    ")], 1), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "type": "number",
      "formatter": _vm.zeroOrGreater,
      "lazy-formatter": ""
    },
    model: {
      value: (_vm.userData.rollSettings.baseValue),
      callback: function($$v) {
        _vm.userData.rollSettings.baseValue = $$v
      },
      expression: "userData.rollSettings.baseValue"
    }
  })], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('b-btn', {
    staticClass: "mr-1",
    attrs: {
      "variant": "primary",
      "size": "lg",
      "id": "rollDiceButton"
    },
    on: {
      "click": function($event) {
        _vm.createRoll(false)
      }
    }
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "sync",
      "fixed-width": ""
    }
  })], 1), _vm._v(" "), (_vm.userData.rollSettings.mode === 'hits') ? _c('b-btn', {
    attrs: {
      "variant": "outline-warning",
      "size": "lg",
      "id": "pushLimitButton"
    },
    on: {
      "click": function($event) {
        _vm.pushLimit(null)
      }
    }
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "chevron-double-up",
      "fixed-width": ""
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('b-tooltip', {
    ref: "rollDiceTooltip",
    attrs: {
      "target": "rollDiceButton",
      "triggers": "hover"
    }
  }, [_vm._v("\n                  Roll the dice!\n                ")]), _vm._v(" "), (_vm.userData.rollSettings.mode === 'hits') ? _c('b-tooltip', {
    ref: "pushLimitTooltip",
    attrs: {
      "target": "pushLimitButton",
      "triggers": "hover"
    }
  }, [_c('h6', [_vm._v("Push the Limit")]), _vm._v("\n                  Spend a point of Edge to add your Edge rating to the dice pool, reroll sixes for extra hits, and ignore the limit.\n                ")]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "Settings"
    }
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.userData.animateDice),
      callback: function($$v) {
        _vm.userData.animateDice = $$v
      },
      expression: "userData.animateDice"
    }
  }, [_vm._v("\n              Animate dice\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('b-btn', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.clearRollHistoryModal",
      modifiers: {
        "clearRollHistoryModal": true
      }
    }],
    attrs: {
      "variant": "outline-danger",
      "size": "lg"
    }
  }, [_vm._v("\n                Clear roll history\n              ")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "lg": "8"
    }
  }, _vm._l((_vm.reversedHistory), function(roll) {
    return _c('roll-info', {
      key: roll.id,
      attrs: {
        "roll": roll,
        "animate": _vm.rollsToAnimate.indexOf(roll.id) !== -1 && _vm.userData.animateDice
      },
      on: {
        "deletedRoll": _vm.deleteRoll,
        "usedPushTheLimit": _vm.pushLimit,
        "usedSecondChance": _vm.secondChance,
        "usedCloseCall": _vm.closeCall
      }
    })
  }))], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b4b4673a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/roller/Roller.vue
// module id = 114
// module chunks = 2